import ReactDOM from "react-dom"
import reportWebVitals from "./reportWebVitals"
import store from "@/store/store"
import { Provider } from "react-redux"
import { Route, Router, Switch } from "react-router-dom"


import LazyComponent from "@eventdex/components/src/components/Utils/LazyComponent"
import history from "@eventdex/bootstrap/src/hostConfig/history"
import IframeChild from "@eventdex/components/src/components/iframe/iframeChild"
import EventdexProvider from "@eventdex/core/src/context/EventdexProvider"
import webSocket from "./services/WebSocket"

import "focus-visible/dist/focus-visible"
import "./i18n/index"
import "./index.css"

// Import the standalone gala preview component
import PreviewGalaLeaflet from "./components/AttendeeGalaLeaf"

let iframeChild = new IframeChild()
iframeChild.init(null)

const App = LazyComponent(() => import("./App"))

function handleEventPermissions(user: any) {
  let payload = { roles: user?.role }
  //emit event
  let EVENT_DATA = new CustomEvent("edex-permissions", { detail: payload })
  dispatchEvent(EVENT_DATA)
  return user?.role?.includes("Scan Attendee") || user?.role?.includes("Gala") || user?.role?.includes("Floor Map")
}

ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <Switch>
        {/* Standalone gala preview route - minimal EventdexProvider with just builder and api module, no auth */}
        <Route exact path="/gala-preview-leaflet/:id/:eventId">
          <EventdexProvider
            hostApp={{
              name: "Badge Designer",
              abbreviation: "bd",
              chatDisabled: true,
              keysToKeepOnLogout: [],
              accessPermissions: {
                hasAccess: () => true, // Always allow access for this route
                errorMessage: "",
                redirectUrl: "",
                logoutOnNoAccess: false
              }
            }}
            isPublic={true}
            store={store}
            history={history}
            modules={() => [
            import("@eventdex/api"),
            import("@eventdex/core"),
            import("@eventdex/builder") // Only the builder module needed
            ]}
          >
            <PreviewGalaLeaflet />
          </EventdexProvider>
        </Route>
        
        {/* All other routes with full EventdexProvider setup */}
        <Route path="*">
          <EventdexProvider
            hostApp={{
              name: "Badge Designer",
              abbreviation: "bd",
              chatDisabled: true,
              keysToKeepOnLogout: [],
              accessPermissions: {
                hasAccess: (user: any) => handleEventPermissions(user),
                errorMessage: "Please purchase a ScanAttendee License to access the Badge Designer",
                redirectUrl: "/events",
                logoutOnNoAccess: false
              }
            }}
            isPublic={true}
            store={store}
            history={history}
            modules={() => [
              import("@eventdex/api"),
              import("@eventdex/auth"),
              import("@eventdex/builder"),
              import("@eventdex/common"),
              import("@eventdex/core"),
              import("@eventdex/event"),
              import("@eventdex/profile")
            ]}
          >
            <Switch>
              <Route path="/iframe" component={null} />
              <Route path="/" component={App} />
            </Switch>
          </EventdexProvider>
        </Route>
      </Switch>
    </Router>
  </Provider>,
  document.getElementById("root")
)

reportWebVitals()
